import { useTranslation } from 'react-i18next';
import ErrorPageTempate from './ErrorPageTempate';

function Error401() {
  const { t } = useTranslation();

  return (
    <ErrorPageTempate
      label={t('Error: Unauthorized.')}
      code={401}
    />
  );
}

export default Error401;
